import { useEffect } from 'react';
import { useSession } from '../../context/SessionContext';
import cartServices from '../../services/CartServices';
import { useCart } from '../../context/CartContext';
import productServices from '../../services/ProductsServices';

let hasInitialized = false;

export default function SessionInitializer() {
    const {
        setBrands, hasBrands,
        setModels, hasModels,
        setProductTypes, hasProductTypes,
    } = useSession();

    const {
        setCart, setNumItems, setItemSlugs, setCustomerProfile,
        cartIsSet
    } = useCart();

    useEffect(() => {
        if (hasInitialized) return;
        hasInitialized = true;

        const initializeSessionData = async () => {
            try {
                if (!cartIsSet) {
                    const cartRes = await cartServices.checkCart();
                    const data = cartRes.data;
                    setCart({ cart_id: data.cart_id });
                    setNumItems(data.num_items || 0);
                    setItemSlugs(data.cart_items || []);
                    if (data.customer_profile) {
                        setCustomerProfile(data.customer_profile);
                    }
                }
            } catch (err) {
                console.warn('⚠️ Cart init failed (anonymous user?)', err.message || err);
                
            }

            const fetchBrands = async () => {
                if (!hasBrands) {
                    try {
                        const res = await productServices.getBrands();
                        setBrands(res.data);
                    } catch (err) {
                        console.error('Ses Product Brands err:', err);
                    }
                }
            };

            const fetchProductTypes = async () => {
                if (!hasProductTypes) {
                    try {
                        const res = await productServices.getProductTypes();
                        setProductTypes(res.data);
                    } catch (err) {
                        console.error('Ses Product Type err:', err);
                    }
                }
            };

            const fetchModels = async () => {
                if (!hasModels) {
                    try {
                        const res = await productServices.getModels();
                        setModels(res.data);
                    } catch (err) {
                        console.error('Ses Product Model err:', err);
                    }
                }
            };

            await Promise.all([
                fetchBrands(),
                fetchProductTypes(),
                fetchModels(),
            ]);
        };

        initializeSessionData();
    }, [
        hasBrands, setBrands,
        hasModels, setModels,
        hasProductTypes, setProductTypes,
        cartIsSet, setCart, setNumItems, setItemSlugs, setCustomerProfile
    ]);

    return null;
}